<template>
  <div class="container">
    <!-- pc -->
    <div v-if="!$deviceState.isMobile">
      <div class="header">
        <p class="title">昌恩暖通智控节能项目投资回报预算列表</p>
        <!-- <p class="newBudget">新增预算</p> -->
        <el-button class="newBudget" type="primary" @click="newBudget"
          >新增预算</el-button
        >
      </div>

      <el-dialog
        append-to-body
        title="新建预算"
        :visible.sync="dialogVisible"
        width="42%"
        :before-close="handleClose"
      >
        <el-form :model="projectForm" ref="projectForm">
          <el-form-item
            label="预算名称："
            label-width="6.25rem"
            required
            :rules="[
              { required: true, message: '请输入预算名称', trigger: 'blur' }
            ]"
            prop="projectName"
          >
            <el-input
              placeholder="请输入预算名称"
              v-model="projectForm.projectName"
            ></el-input>
          </el-form-item>
        </el-form>
        <!--  -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="colseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog">确 定</el-button>
        </span>
      </el-dialog>

      <el-card class="box-card set-scroll">
        <el-table
          :data="tableData"
          style="width: 100%"
          @row-click="clickControl"
        >
          <!-- <el-table-column type="index" width="60"> </el-table-column> -->
          <el-table-column label="序号" min-width="30">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (pageData.pageNum - 1) * pageData.pageSize
              }}
            </template>
          </el-table-column>

          <!-- <el-table-column prop="date" label="日期" width="160">
        </el-table-column> -->
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column
            prop="HVAC_EnergyConsumption_Annual"
            label="项目暖通系统年用电量"
          >
          </el-table-column>
          <el-table-column prop="HVAC_AveragePSR_Annual" label="年均节能率">
          </el-table-column>

          <el-table-column prop="HVAC_PowerSavings_Annual" label="年均节电量">
          </el-table-column>

          <el-table-column prop="HVAC_PowerSavings_Monthly" label="月均节电量">
          </el-table-column>

          <el-table-column prop="Power_UnitPrice" label="电费单价">
          </el-table-column>

          <el-table-column prop="HVAC_Savings_Total" label="项目年均总节电费">
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.pageNum"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </el-card>
    </div>

    <!-- mb -->
    <div v-else>
      <mobileHome></mobileHome>
    </div>
  </div>
</template>

<script>
import mobileHome from '@/views/mobile/home.vue'
import { getOffer } from '@/api/home/index'
export default {
  components: { mobileHome },
  data () {
    return {
      dialogVisible: false,
      projectForm: { projectName: '' },
      tableData: [
        // {
        //   date: '2016-05-02',
        //   name: '王小虎',
        //   money: '项目预算 1518 '
        // },
        // {
        //   date: '2016-05-04',
        //   name: '王小虎',
        //   money: '项目预算 1517 '
        // },
        // {
        //   date: '2016-05-01',
        //   name: '王小虎',
        //   money: '项目预算 1519 '
        // },
        // {
        //   date: '2016-05-03',
        //   name: '王小虎',
        //   money: '项目预算 1516 '
        // }
      ],
      totalPage: 0,
      pageData: {
        userName: JSON.parse(localStorage.getItem('userInfo')).userName,
        pageSize: 12,
        pageNum: 1
      }
    }
  },
  mounted () {
    this.initData(this.pageData)
  },
  methods: {
    async initData (page) {
      try {
        const res = await getOffer(page)
        this.tableData = res.data.data
        this.totalPage = res.data.total
        console.log('列表', res.data.data)
      } catch (error) {}
    },

    // 弹框

    newBudget () {
      this.dialogVisible = true
      // this.$router.push({
      //   path: 'budgetSheet'
      // })
    },
    handleClose () {
      this.dialogVisible = false
      this.$refs.projectForm.resetFields()
    },
    confirmDialog () {
      console.log('名字')

      this.$refs.projectForm.validate(valid => {
        if (valid) {
          this.dialogVisible = false
          this.$router.push({
            path: 'budgetSheet',
            query: {
              name: this.projectForm.projectName
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    colseDialog () {
      this.dialogVisible = false
      this.$refs.projectForm.resetFields()
    },
    //
    clickControl (row) {
      console.log('点击项id', row.id)
      this.$router.push({
        path: 'budgetSheet',
        query: {
          id: row.id,
          title: 1
        }
      })
    },
    handleSizeChange () {},
    handleCurrentChange (page) {
      this.pageData.pageNum = page
      this.initData(this.pageData)
      console.log('选择页码', page)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 70px);
  padding: 10px 16px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  margin: 20px 20px 20px 0;
  padding-bottom: 10px;
  text-align: left;
  color: rgba(@homeBoxColor, 0.9);
  font-size: 30px;
  font-weight: 600;
}
.newBudget {
  position: absolute;
  right: 30px;
  // margin-right: 50px;
}
.box-card {
  // height: 100%;
  height: calc(100vh - 160px);
  overflow: auto;
}

.el-pagination {
  margin-top: 20px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}
.el-button--default {
  margin: 0 20px;
}

//
.dialog-footer {
  .el-dialog__footer {
    text-align: center !important;
  }
  .el-button {
    font-size: 1.2em;
    padding: 0.5em;
    border-radius: 0.2em;
    margin: 0.6em;
  }
}
</style>
